angular.module('skeyenoteWebApp').service('loaderSrv', LoaderService);

function LoaderService() {
  'ngInject';

  this.showLoader = function() {
    angular.element('#pre-loader').fadeIn();
  };

  this.hideLoader = function() {
    angular.element('#pre-loader').fadeOut();
  };
}
